import React from 'react'
import ClassName from 'classnames'
import ObjectToQueryString from 'lib/objectToQueryString'
import styles from './Map.module.scss'

const Map = ({ apiKey, className = '', title = 'map', parameters }) => {
  const formatedParameters = parameters
  formatedParameters.q =
    formatedParameters.q && formatedParameters.q.replace(' ', '+')

  const queryString = ObjectToQueryString(formatedParameters)
  const url = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&${queryString}`
  return (
    <iframe
      title={title}
      src={url}
      className={ClassName(styles.map, className)}
    />
  )
}

export default React.memo(Map)
